'use client';

import { useDrawer } from '@cat-ecom/pcc-components';
import { createContext, useContext, useMemo } from 'react';
import { DealerLocatorLoaderProvider } from './dealer-locator-loader-context';

type DealerLocatorDrawerProviderProps = {
  isStoreLocationListViewUpdateFlag?: boolean;
  isStoreLocationMapViewUpdateFlag?: boolean;
  isStoreLocationTandCFlag?: boolean;
  isStoreLocationPinEnhancementFlag?: boolean;
  isStoreLocationOptimizationFlag?: boolean;
  children: React.ReactNode;
  isfullMapViewMobileFlagEnabled?: boolean;
};
type DealerLocatorDrawerContextType = ReturnType<typeof useDrawer> & {
  isStoreLocationListViewUpdateFlag?: boolean;
  isStoreLocationMapViewUpdateFlag?: boolean;
  isStoreLocationTandCFlag?: boolean;
  isStoreLocationPinEnhancementFlag?: boolean;
  isfullMapViewMobileFlagEnabled?: boolean;
  isStoreLocationOptimizationFlag?: boolean;
};
const DealerLocatorDrawerContext =
  createContext<DealerLocatorDrawerContextType>(null);
export const useDealerLocatorDrawer = () =>
  useContext(DealerLocatorDrawerContext);

export const DealerLocatorDrawerProvider = ({
  children,
  isStoreLocationListViewUpdateFlag = false,
  isStoreLocationTandCFlag = false,
  isStoreLocationPinEnhancementFlag = false,
  isStoreLocationMapViewUpdateFlag = false,
  isfullMapViewMobileFlagEnabled,
  isStoreLocationOptimizationFlag = false
}: DealerLocatorDrawerProviderProps) => {
  const dealerLocatorDrawer = useDrawer({ size: 'lg' });
  const dealerLocatorContextValue = useMemo(
    () => ({
      ...dealerLocatorDrawer,
      isStoreLocationListViewUpdateFlag,
      isStoreLocationTandCFlag,
      isStoreLocationPinEnhancementFlag,
      isStoreLocationMapViewUpdateFlag,
      isfullMapViewMobileFlagEnabled,
      isStoreLocationOptimizationFlag
    }),
    [
      dealerLocatorDrawer,
      isStoreLocationListViewUpdateFlag,
      isStoreLocationMapViewUpdateFlag,
      isStoreLocationTandCFlag,
      isStoreLocationPinEnhancementFlag,
      isfullMapViewMobileFlagEnabled,
      isStoreLocationOptimizationFlag
    ]
  );
  return (
    <DealerLocatorLoaderProvider>
      <DealerLocatorDrawerContext.Provider value={dealerLocatorContextValue}>
        {children}
      </DealerLocatorDrawerContext.Provider>
    </DealerLocatorLoaderProvider>
  );
};
